import { IGame } from "@grassrootly/api";
import { Div, Label } from "@grassrootly/rn-core";
import moment from "moment";

export default function GameDetails({ game }: { game: IGame }) {
  return (
    <Div classNames={["flex1", "p24"]}>
      <Div classNames={["mb-{24}"]}>
        <Label classNames={["colorPrimaryMain", "mb-{5}"]}>Kick-off time</Label>
        <Label>{moment(game.datetime).format("dddd DD.MM.YYYY HH:mm")}</Label>
      </Div>
      <Div classNames={["mb-{24}"]}>
        <Label classNames={["colorPrimaryMain", "mb-{5}"]}>Location</Label>
        <Label>{game.location}</Label>
      </Div>
      <Div classNames={["mb-{24}"]}>
        <Label classNames={["colorPrimaryMain", "mb-{5}"]}>Note</Label>
        <Label>{game.notes}</Label>
      </Div>
    </Div>
  );
}
